module.exports = __webpack_public_path__ + "28e98b08e603d6785f395ea05d1aaf02.fbx";